// extracted by mini-css-extract-plugin
export default {"filterContainer":"FilterWindow_filterContainer__8xpTm","filterArrow":"FilterWindow_filterArrow__jgdr2","placeHolderShimmer":"FilterWindow_placeHolderShimmer__Hvmxq"};